module.exports = __webpack_public_path__ + "img/train-8.89c4bfd3.jpg";